import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useEffect, useRef } from 'react';

import { TextButton } from '@flipster/react/design-system/text-button';
import { Explain } from '@flipster/react/design-utils/explain';
import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import { adjustMarginStateBunja } from '../state';

interface Props {
  message: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

const ErrorMessage = ({ message, action }: Props) => {
  const prevMessageRef = useRef<string>(undefined);
  const { tabAtom, currentPositionAtom } = useBunja(adjustMarginStateBunja);
  const currentPosition = useAtomValue(currentPositionAtom);
  const tab = useAtomValue(tabAtom);

  useEffect(() => {
    if (!currentPosition || message === prevMessageRef.current) return;
    prevMessageRef.current = message;
    segment.track(TradeEvent.OrderFormErrorMsgView, {
      error_message: message,
      error_case: tab === 'add' ? 'add_position' : 'remove_funds',
      is_recommendation_chip_visible: false,
      symbol: currentPosition.symbol,
      leverage: currentPosition.initLeverage,
      order_by_token: 'margin',
    });
  }, [message, tab, currentPosition]);

  return (
    <Explain.Error hideIcon css={{ display: 'inline', textStyle: 'Text/M/Regular' }}>
      {message}{' '}
      {action && (
        <TextButton
          color='sell'
          label={action.label}
          size='medium'
          onClick={() => {
            if (!currentPosition) return;
            segment.track(TradeEvent.OrderFormErrorMsgClick, {
              error_message: message,
              error_case: tab === 'add' ? 'add_position' : 'remove_funds',
              symbol: currentPosition.symbol,
              leverage: currentPosition.initLeverage,
              order_by_token: 'margin',
            });
            action.onClick();
          }}
        />
      )}
    </Explain.Error>
  );
};

export default ErrorMessage;
